module.exports = __webpack_public_path__ + "pc/img/file_word.17d484ec.png";